import axios from "axios";
import auth from "./auth";

// Fire-and-forget client analytics. Posts to the whitelisted /events endpoint.
// No-ops for logged-out visitors and never throws into the caller's flow.
// Server-side events (login, enroll, payment, completion, …) are logged by the
// API itself — this only covers engagement the backend can't see (mode switches,
// chapter plays, resource downloads).
export default function track(type, { course, chapter, meta } = {}) {
	if (!auth.isAuthenticated()) return;
	try {
		axios
			.post(
				"/events",
				{ type, course, chapter, meta },
				{ headers: { "x-auth-token": auth.getToken() } }
			)
			.catch(() => {});
	} catch (_) {
		/* never let analytics break the UI */
	}
}
